import { createPinia } from "pinia";
import { useOrderStore } from "./store";
import { createApp } from "vue";
import OrderApp from "./OrderApp.vue";
import { extractData } from "../../utils";
export default function initOrderApp(dadataToken) {
    const appElement = document.getElementById('orderApp');
    if (!appElement) {
        return;
    }
    const pinia = createPinia();
    const store = useOrderStore(pinia);
    const data = extractData(appElement);
    store.setOrderSum(data.orderSum);
    store.paymentSystems = data.payments.systems;
    store.paymentSystem = data.payments.system;
    store.bonusAmount = data.bonuses.amount;
    store.usedBonuses = data.bonuses.used === '' ? undefined : data.bonuses.used;
    createApp(OrderApp, {
        address: data.address,
        allowSkipCall: data.allowSkipCall,
        cdek: data.cdek,
        cashPaymentAllowRegions: data.payments.allowCashRegions,
        cashPaymentBanned: !data.payments.allowCash,
        cashPaymentDiscount: data.payments.cashPaymentDiscount,
        userLoggedIn: data.loggedIn,
        errors: data.errors,
        formData: data.formData,
        token: dadataToken,
    }).use(pinia).mount(appElement);
}
